import { useEffect, useState } from "react";
import { api, formatCHF, formatDate, PAYMENT_METHOD_LABELS } from "../lib/api";
import { StatusBadge } from "../components/nivara/StatusBadge";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n/I18nContext";

export default function PaymentsPage() {
  const { user } = useAuth();
  const t = useT();
  const [payments, setPayments] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupFilter, setGroupFilter] = useState("");

  const load = async () => {
    const url = groupFilter ? `/payments?group_id=${groupFilter}` : "/payments";
    const { data } = await api.get(url);
    setPayments(data);
  };

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/groups");
      setGroups(data);
    })();
  }, []);
  useEffect(() => { load(); }, [groupFilter]);

  const check = async (id) => { await api.patch(`/payments/${id}`, { status: "checked" }); await load(); };
  const release = async (id) => { await api.patch(`/payments/${id}`, { status: "released" }); await load(); };

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-8">
      <div className="mb-6">
        <div className="nv-label">{t("nav.payments")}</div>
        <h1 className="font-heading text-3xl font-medium text-[#0F4C3A] mt-2" data-testid="payments-page-title">{t("payments.title")}</h1>
      </div>
      <div className="mb-4 flex gap-3 flex-wrap">
        <select value={groupFilter} onChange={(e) => setGroupFilter(e.target.value)} data-testid="group-filter" className="px-3 py-2 border border-[#E2E8E4] rounded-md">
          <option value="">{t("payments.all_groups")}</option>
          {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
      </div>
      <div className="nv-border bg-white rounded-md overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-[#F8FAF9] border-b border-[#E2E8E4]">
            <tr>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("payments.col.date")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("payments.col.month")}</th>
              <th className="nv-label p-3 text-right whitespace-nowrap">{t("payments.col.amount")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("payments.col.method")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("payments.col.status")}</th>
              <th className="nv-label p-3 text-right whitespace-nowrap">{t("payments.col.action")}</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} className="border-b border-[#E2E8E4] hover:bg-[#F8FAF9]" data-testid={`payment-${p.id}`}>
                <td className="p-3 text-sm">{formatDate(p.paid_at)}</td>
                <td className="p-3 font-mono-nv text-sm">{t("dashboard.month")} {p.month}</td>
                <td className="p-3 font-mono-nv font-semibold text-right">CHF {formatCHF(p.amount)}</td>
                <td className="p-3 text-sm">
                  {PAYMENT_METHOD_LABELS[p.method]}
                  {p.paid_by_name && <div className="text-xs text-[#94A3B8]">{t("group.paid_by")} {p.paid_by_name}</div>}
                </td>
                <td className="p-3"><StatusBadge status={p.status} /></td>
                <td className="p-3 text-right">
                  {p.status === "paid" && (
                    <button onClick={() => check(p.id)} data-testid={`check-${p.id}`} className="px-3 py-1 text-xs border border-[#0369A1] text-[#0369A1] rounded hover:bg-[#E0F2FE]">{t("group.action_check")}</button>
                  )}
                  {p.status === "checked" && user?.role === "admin" && (
                    <button onClick={() => release(p.id)} data-testid={`release-${p.id}`} className="ml-2 px-3 py-1 text-xs nv-btn-gold rounded">{t("group.action_release")}</button>
                  )}
                </td>
              </tr>
            ))}
            {payments.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-[#94A3B8]">{t("payments.no_data")}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
